import { z } from 'zod';
import { idSchema } from '../../ontology/primitives.ts';
import {
  kindTallySchema,
  readReceiptSchema,
  telegramStateSchema,
  wireNotificationSchema,
} from './notification.ts';
import { wirePositionSchema } from './position.ts';
import { instant } from './primitives.ts';
import {
  bookOrderSchema,
  wireAnalystRefSchema,
  wireQuoteSchema,
  wireRecommendationSchema,
  wireRoiRecommendationSchema,
} from './recommendation.ts';
import { viewerSchema } from './viewer.ts';

export const serverFrameSchema = z.discriminatedUnion('t', [
  z.object({
    t: z.literal('hello'),
    viewer: viewerSchema,
    books: bookOrderSchema,
    now: instant,
  }),
  z.object({
    t: z.literal('snapshot'),
    recommendations: z.array(wireRecommendationSchema),
    positions: z.array(wirePositionSchema),
    quotes: z.array(wireQuoteSchema),
    books: bookOrderSchema,
    analysts: z.array(wireAnalystRefSchema),
    record: z.array(wireRoiRecommendationSchema),
    notifications: z.array(wireNotificationSchema),
    unread: z.number().int(),
    tally: z.array(kindTallySchema),
  }),
  z.object({
    t: z.literal('notifications'),
    upsert: z.array(wireNotificationSchema),
    read: readReceiptSchema.optional(),
    unread: z.number().int(),
    tally: z.array(kindTallySchema),
  }),
  z.object({
    t: z.literal('recommendations'),
    upsert: z.array(wireRecommendationSchema),
    remove: z.array(idSchema),
    record: z.array(wireRoiRecommendationSchema),
  }),
  z.object({
    t: z.literal('positions'),
    upsert: z.array(wirePositionSchema),
    remove: z.array(idSchema),
  }),
  z.object({ t: z.literal('viewer'), viewer: viewerSchema }),
  z.object({ t: z.literal('telegram'), telegram: telegramStateSchema }),
  z.object({ t: z.literal('quotes'), quotes: z.array(wireQuoteSchema) }),
]);

export type ServerFrame = z.infer<typeof serverFrameSchema>;

export const clientFrameSchema = z.discriminatedUnion('t', [z.object({ t: z.literal('resync') })]);

export const SOCKET_PATH = '/api/stream';

/** Session ended: the client must not reconnect. Every other close is retried. */
export const SOCKET_CLOSED_SIGNED_OUT = 4401;
